import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableUseType = 'indoor' | 'outdoor';

const options = [
    { value: 'indoor', label: 'Indoor' },
    { value: 'outdoor', label: 'Outdoor' },
] as Option<CableUseType>[];

const validator = z.array(z.enum(['indoor', 'outdoor']));

export const CableUse = {
    validator,
    options,
};
